export default __webpack_public_path__ + "static/steveklbnf@2x-edafce52ff73d055dba08e351a652bba.jpg";